module.exports = __webpack_public_path__ + "files/e4a512ee43a3f075e92fde88ea3dc4a8.png";